import { Navigate } from "react-router-dom";

export default function Onboarding() {
  return <Navigate to="/candidate/profile" replace />;
}
